import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import omit from 'lodash/omit'

import Link from '@eig-builder/control-link'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

const CustomLink = forwardRef((props, ref) => (
  <Link
    dataElementLocation={DataElementLocations.BODY}
    dataElementLabel={`cst-core-link-button--link-${props.dataElementSuffix}`}
    dataElementId={`cst-core-link-button--link-${props.dataElementSuffix}`}
    {...omit(props, 'dataElementSuffix', 'tabIndex')}
  />
))

CustomLink.propTypes = {
  dataElementSuffix: PropTypes.string.isRequired
}

export default CustomLink
